import moment from "moment";
import { RiFileList3Fill } from "react-icons/ri";
import {
  COSTUM,
  DATE,
  SELECT,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { HISOBOT } from "../../Component/Sidebar/PageTypes";
import PrintBtn from "./components/PrintBtn";
import Refresh from "./components/Refresh";
const OstatkaPM = {
  title: "Реестр махсулот",
  path: "/hisobot/plus-minus-ostatka",
  icon: <RiFileList3Fill></RiFileList3Fill>,
  type: HISOBOT,
  allData: [
    { value: "tovar_id", prop: "tovarlar", get: "nomi" },
    { value: "table_name", prop: "jarayonlar", get: "nomi" },
  ],
  hisobotActions: [
    {
      grid: "1fr 1fr 1fr 1fr 1fr",
      inputs: [
        {
          label: "Сана",
          name: "sana1",
          type: DATE,
        },
        {
          label: "Сана 2",
          name: "sana2",
          type: DATE,
          secondDate: true,
        },
        {
          label: "Жараён",
          name: "table_name",
          type: SELECT,
          allData: {
            type: "jarayonlar",
            key: "table_name",
            text: "nomi",
          },
        },
        {
          label: "Махсулотлар",
          name: "maxsulot_id",
          type: SELECT,
          allData: {
            type: "tovarlar",
            key: "Id",
            text: "nomi",
          },
        },
        {
          type: COSTUM,
          component: (
            <div
              style={{ display: "flex", gridGap: "10px", alignItems: "center" }}
            >
              <Refresh text="Янгилаш"></Refresh>
              <PrintBtn></PrintBtn>
            </div>
          ),
        },
      ],
    },
  ],
};
export default OstatkaPM;
